import React from "react";
import { Route, Switch } from "react-router-dom";
import { SendToDeviceV2Container } from "../SendToDeviceV2";
import { TRouteShowPage } from "../TRouteShowPage";

export const routes = ({ match: { path } }) => (
  <Switch>
    <Route path={`${path}/`} exact component={TRouteShowPage} />
    <Route path={`${path}/send_to_device`} component={SendToDeviceV2Container} />
  </Switch>
);
